import React from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import { selectUserDetail } from '../../../store/selectors/userListSelector';

import ActiveUserView from './components/workerComponents/ActiveUserView';
// import OnboardingIncompleteCard from './components/OnboardingIncompleteCard';
// import WaitingVerificationCard from './components/WaitingVerificationCard';
const UserDetailRight = () => {
  const selectedUser = useSelector(selectUserDetail)?.[0];

  // TODO: this could  be removed once we confirm we don't need it anymore,if decided to remove clean up OnboardingIncompleteCard, WaitingVerificationCard and change naming of ActiveUserView to UserDetailView
  // const renderCard = (status) => {
  //   switch (status) {
  //     case USER_STATUS.ONBOARDING_INCOMPLETE:
  //       return <OnboardingIncompleteCard />;
  //     case USER_STATUS.UNVERIFIED:
  //       return <WaitingVerificationCard />;
  //     case USER_STATUS.SUSPENDED:
  //     case USER_STATUS.DEACTIVATED:
  //     case USER_STATUS.DNA:
  //     case USER_STATUS.ACTIVE:
  //       return <ActiveUserView selectedUser={selectedUser} />;
  //     default:
  //       return <Box>{LanguageConverter('userDetail.unrecognized')}</Box>;
  //   }
  // };

  return (
    <Box>
      <Box>
        <ActiveUserView selectedUser={selectedUser} />
      </Box>
    </Box>
  );
};

export default UserDetailRight;
